import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useNavigationHistory = () => {
    const location = useLocation();
    const [history, setHistory] = useState([]);

    useEffect(() => {
        setHistory(prevHistory => [...prevHistory, location.pathname]);
    }, [location]);

    return history;
};

export default useNavigationHistory;